// @core/api/endpoints/project/create_board.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BoardResponse,
  CreateBoardRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create board
 * Creates a new Kanban or Scrum board for the project with specified columns and display settings. Multiple boards can exist per project for different views.
 */
export async function CreateBoard(
  project_id: string,
  data: CreateBoardRequest,
  options?: RequestOptions
): Promise<BoardResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/boards`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<BoardResponse>(requestPath, data, requestOptions);
}
